import styled from 'styled-components';

const INK = '#27272A'; // texto principal (neutral-800)
const MUTED = '#71717A'; // rótulos (neutral-500)
const LINE = '#d4d4d8'; // divisórias (neutral-300)

export const Card = styled.section`
    overflow: hidden;
    border-radius: 0.875rem;
    padding: 1rem 1.2rem 1.05rem;
    margin-bottom: 1.25rem;
    background: #ffffff;
    border: 1px solid #e4e4e7;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;

    .itinerary {
        display: flex;
        align-items: flex-end;
        gap: 0.9rem;
    }

    @media (max-width: 380px) {
        .itinerary {
            gap: 0.6rem;
        }
    }
`;

export const Eyebrow = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${INK};

    svg {
        color: #ffcf00;
    }
`;

export const Leg = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    &.end {
        text-align: right;
        align-items: flex-end;
    }
`;

export const LegLabel = styled.span`
    font-size: 0.66rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${MUTED};
`;

export const LegDate = styled.span`
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.1;
    color: ${INK};
    font-variant-numeric: tabular-nums;
`;

export const Connector = styled.div`
    flex: 1;
    min-width: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding-bottom: 0.35rem;
`;

export const Track = styled.span`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    width: 100%;

    .line {
        flex: 1;
        height: 0;
        border-top: 1.5px dashed ${LINE};
    }

    svg {
        flex-shrink: 0;
        color: #ffcf00;
    }
`;

export const Instruction = styled.p`
    margin: 0;
    font-size: 0.82rem;
    line-height: 1.45;
    color: ${MUTED};
`;
